// * Add class to DOM element.  IE9 safe.
export const addClass = (el, cls) => {
  try {
    // * Throw errors unless required elements are provided.
    if (!el) throw Error('!!! ERROR (DOM.fns.classList.add): Unable to add class.  No element provided.', el)
    if (!cls) throw Error('!!! ERROR (DOM.fns.classList.add): Unable to add class.  No class provided.', el)

    if ('classList' in document.documentElement) {
      el.classList.add(cls)
    } else {
      var cur = ' ' + el.className + ' '
      if (cur.indexOf(' ' + cls + ' ') < 0) {
        el.className = (cur + cls).trim()
      }
    }
  } catch (error) {
    MK.captureException && MK.captureException(error)
    return null
  }
}
